export default __webpack_public_path__ + "static/media/image-on-edge.64585216.jpg";